/**
 * TalkJS dashboard setup (artist role, both apps):
 * 1. Chat UI → Custom message actions → add action name `savePhoto`, label "Save photo",
 *    allowed on All messages.
 * 2. Themes `porter_mobile` / `business_web` must render `<ActionMenu>` on UserMessage
 *    so the action appears in the message menu.
 *
 * Labels stay static in TalkJS; destination is communicated via success toast.
 */
export const SAVE_CHAT_PHOTO_ACTION = 'savePhoto';
